
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicCategoriesApi extends BaseModulePublicApi {
  basePath = 'categories';

  /**
   * Returns the public category hierarchy used to describe a visit
   * (museum -> floor -> room -> object).  Keep this separate from getList:
   * consumers that still need a flat category list retain their behaviour.
   */
  async getVisitTree(headers: any, filters: any, configOptions?: any) {
    const domains = [this.domain];
    if (this.domain.includes('rmc.findify.cloud') && this.domain !== 'rmc.findify.cloud') domains.push('rmc.findify.cloud');
    let lastError: any;
    for (const domain of domains) {
      try {
        const response = await this.axiosInstance!.get(`/front/${domain}/${this.basePath}/visit`, {
          params: filters,
          headers: headers ?? undefined,
          ...configOptions,
        });
        if (response.status === 200) return response.data;
      } catch (error) {
        lastError = error;
      }
    }
    throw lastError;
  }
};
